import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from '@mui/material'
import React, { FC, useMemo, useState } from 'react'

import { UserProfile } from '../../../sdk'
import { ModifyObjectType } from '../../../utils'

type Props = ModifyObjectType<
  SelectProps,
  {
    techs: UserProfile[]
    techOptions: UserProfile[]
    handleTechChange: (techId: string) => void
  }
>

export const TechnicianSingleSelectUI: FC<Props> = ({
  techs,
  techOptions,
  handleTechChange,
  ...props
}) => {
  const [open, setOpen] = useState(false)
  // handle archived tech
  const modifiedTechOptions: UserProfile[] = useMemo(() => {
    const options = [...techOptions]
    const optionIds = (techOptions || []).map((t) => t.id!)
    for (const tech of techs) {
      if (!optionIds.includes(tech.id!)) {
        options.push(tech)
      }
    }
    return options
  }, [techOptions, techs])
  return (
    <FormControl
      fullWidth
      data-testid="technicianSelect"
      variant="standard"
      size="small">
      <InputLabel id="techLabel">Technician</InputLabel>
      <Select
        labelId="techLabel"
        label="Technician"
        data-testid="RepairOrderTechInput"
        value={techs.length > 0 ? techs[0].id! : ''}
        onChange={(event) => {
          event.stopPropagation()
          handleTechChange(event.target.value as string)
        }}
        open={open}
        onClose={(event) => {
          event.stopPropagation()
          setOpen(false)
        }}
        onOpen={(event) => {
          event.stopPropagation()
          setOpen(true)
        }}
        {...props}>
        {modifiedTechOptions.map((user) => (
          <MenuItem
            key={user.id!}
            value={user.id! as string}
            data-testid={user.id!}>
            {user.name!}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
